export default __webpack_public_path__ + "static/media/kuvantaminen-lightblue.42fa903b.svg";